import { database } from "./database";
import { ref, set, onChildAdded } from "firebase/database";

export function pushMoveToFirebase(
  gameID: string,
  move: string,
  moveNumber: number
) {
  console.log(`Pushing move to games/${gameID}/moves/${moveNumber}`);
  const moveListRef = ref(database, `games/${gameID}/moves/${moveNumber}`);
  set(moveListRef, move).then(() => {
    console.log(`${move} pushed to database`);
  });
}

export function moveMadeListener(
  gameID: string,
  moveHandler: CallableFunction
) {
  const moveListRef = ref(database, `games/${gameID}/moves`);
  return onChildAdded(moveListRef, (data) => {
    console.log("Received data: ", data.val());
    const move = data.val();
    moveHandler(move);
  });
}
